import React, { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Text } from "@react-three/drei";

const getDirectionIcon = (direction) => {
  switch (direction) {
    case 6: return "← →";
    case 2: return "←";
    case 3: return "→";
    case 0: return "✕";
    default: return "?";
  }
};

const SlidingPanel = ({ isExporting, section, isDouble, index, titleIndex, direction, panelWidth, height, isOpenTrigger, side, spacing, panelRefs, totalPanels, leftAngle, rightAngle, almColor, glassColor, glassColor2 }) => {
  const frameThickness = 0.025;
  const panelHeight = height - 0.02;
  const edgeOffset = panelWidth / 2 - frameThickness / 2;
  const verticalOffset = panelHeight / 2 - frameThickness / 2;
  const isEdgePanel = (side === "right" && index === 0) || (side === "left" && index === 0);
  const edgeThickness = isEdgePanel ? frameThickness * 2 : frameThickness;
  let offset = index * (panelWidth + spacing);
  if (section.sliding_direction == 10 || section.sliding_direction == 2) offset += (panelWidth / 2);
  else if (totalPanels === 1) offset -= 0.01;
  else if (totalPanels === 2) offset -= (totalPanels - 1.5) * panelWidth - 0.01;
  else if (totalPanels === 3) offset -= (totalPanels - 2) * panelWidth - 0.02;
  else if (totalPanels === 4) offset -= (totalPanels - 2.5) * panelWidth - 0.03;
  else if (totalPanels === 5) offset -= (totalPanels - 3) * panelWidth - 0.04;
  const baseX = side === "right" ? offset : -offset;

  let zOffset;
  if (section.sliding_direction == 10) {
    // içeri açılma (mevcut mantık)
    zOffset = -0.033 * index;
  } else if (section.sliding_direction == 2) {
    // dışarı açılma → tersine gitmeli
    zOffset = 0.033 * index - totalPanels/2 * frameThickness;
  } else {
    zOffset = -0.033 * index; // default
  }
  const groupRef = panelRefs[index];
  const thickness = 0.01;
  const reachedRef = useRef(false);
  const targetRef = useRef(null);

  useEffect(() => {
    if (!groupRef.current) return;

    // SADECE isOpenTrigger === true iken pozisyonu ayarla (ilk açılışta)
    if (isOpenTrigger) {
      groupRef.current.position.x = baseX;

      groupRef.current.userData.reached = true;
    } else {
      groupRef.current.userData.reached = false;
    }
    targetRef.current = baseX;
    reachedRef.current = false;

  }, [isOpenTrigger]);

  useFrame(() => {
    if (!groupRef.current) return;

    const current = groupRef.current;

    if (isOpenTrigger) {
      // AÇILMA – mevcut çalışan mantık (dokunmuyoruz)
      const nextPanel = panelRefs[index + 1]?.current;
      const prevPanel = panelRefs[index - 1]?.current;

      const isLeftMerdiven = side === "left" && leftAngle != 0;
      const isRightMerdiven = side === "right" && rightAngle != 0;

      const shouldMove =
        index === 0 || (prevPanel?.userData?.reached && !reachedRef.current);

      if (shouldMove && nextPanel) {
        let targetX = nextPanel.position.x;
        if (isLeftMerdiven) targetX += 0.06;
        if (isRightMerdiven) targetX -= 0.06;

        const dx = targetX - current.position.x;
        current.position.x += dx * 0.04;

        if (Math.abs(dx) < 0.0001) {
          current.position.x = targetX;
          reachedRef.current = true;
          current.userData.reached = true;
        }
      }
    } else {
      // KAPANMA – sırayla geri dönüş
      const nextPanel = panelRefs[index + 1]?.current;

      const shouldMove =
        index === panelRefs.length - 1 || (nextPanel?.userData?.reached === false && !reachedRef.current);

      if (shouldMove) {
        const dx = baseX - current.position.x;
        current.position.x += dx * 0.04;

        if (Math.abs(dx) < 0.0001) {
          current.position.x = baseX;
          reachedRef.current = true;
          current.userData.reached = false;
        }
      }
    }
  });

  const textPositionZ = isDouble ? (thickness + 0.02) : (thickness / 2 + 0.001);
  return (
    <group ref={groupRef} position={[baseX, height / 2, zOffset + 0.05]}>
      {/* 1. Cam (ön cam) */}
      <mesh position={[0, 0, -0.01]}>
        <boxGeometry args={[panelWidth - 0.05, panelHeight, thickness / 2]} />
        <meshStandardMaterial color={glassColor} transparent opacity={0.5} />
      </mesh>

      {/* 2. Cam (arka cam) */}
      {isDouble && (
        <mesh position={[0, 0, 0.01]}>
          <boxGeometry args={[panelWidth - 0.05, panelHeight, thickness / 2]} />
          <meshStandardMaterial color={glassColor2} transparent opacity={0.5} />
        </mesh>
      )}
      <mesh position={[0, verticalOffset, 0]}><boxGeometry args={[panelWidth, frameThickness * 4, thickness + 0.02]} /><meshStandardMaterial color={almColor} /></mesh>
      <mesh position={[0, -verticalOffset, 0]}><boxGeometry args={[panelWidth, frameThickness * 4, thickness + 0.02]} /><meshStandardMaterial color={almColor} /></mesh>
      <mesh position={[-edgeOffset, 0, 0]}><boxGeometry args={[edgeThickness, panelHeight, thickness + 0.02]} /><meshStandardMaterial color={almColor} /></mesh>
      <mesh position={[edgeOffset, 0, 0]}><boxGeometry args={[edgeThickness, panelHeight, thickness + 0.02]} /><meshStandardMaterial color={almColor} /></mesh>
      {isEdgePanel && (
        <mesh position={[side === "left" ? (edgeOffset - edgeThickness / 2 + 0.02) : (-edgeOffset - edgeThickness / 2 + 0.02), 0, thickness / 2 + 0.02]}>
          <boxGeometry args={[0.02, 0.15, 0.03]} />
          <meshStandardMaterial color="black" />
        </mesh>
      )}
      {/* YÖN İKONU - CAM ÜZERİNDE */}
      {!isExporting && (<Text
        position={[0, 0, textPositionZ]}
        fontSize={0.2}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[0, 0, 0]}
      >
        {getDirectionIcon(direction)}
      </Text>)}

      {!isExporting && (<Text
        position={[0, height / 2 - 0.2, textPositionZ]}
        fontSize={0.2}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[0, 0, 0]}
      >
        {titleIndex + 1}
      </Text>)}
    </group>
  );
};

export default SlidingPanel;